import {Component} from '@angular/core';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    standalone: false
})
export class DashboardComponent {
}
